/**
 * Drawer mode determines how the drawer interacts with the main content
 * - 'push': Main content shrinks to accommodate the drawer (no overlap)
 * - 'overlay': Drawer overlays the content with a backdrop
 */
export type DrawerMode = 'push' | 'overlay';

/**
 * Drawer position determines which side the drawer slides in from
 */
export type DrawerPosition = 'left' | 'right';

/**
 * Configuration interface for drawer component
 */
export interface DrawerConfig {
  /** Whether the drawer is open */
  open?: boolean;
  /** The drawer mode - 'push' or 'overlay' */
  mode?: DrawerMode;
  /** Position of the drawer - 'left' or 'right' */
  position?: DrawerPosition;
  /** Width of the drawer (CSS value, e.g., '320px', '25%') */
  width?: string;
  /** Whether to show backdrop in overlay mode */
  showBackdrop?: boolean;
}
